module.exports = __webpack_public_path__ + "static/media/Dog Sitter.f075e3d4.jpg";